import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { slugify } from "../../../../utils/slug";
import UniForm from "../../../../Components/Form/UniForm";
import { showSuccessToast, showErrorToast } from "../../../../toastmsg";

// ✅ Map Firestore data to form data
const mapFirestoreToForm = (data: any) => ({
  universityName: data.universityName || "",
  intro: data.intro || "",
  keyInfo: data.keyInfo || [],
  rankings: data.rankings || [],
  campus: data.campus || [],
  country: data.country || "",
  degreeIntake: data.degreeIntake || [],
  diplomaIntake: data.diplomaIntake || [],
  foundationIntake: data.foundationIntake || [],
  masterIntake: data.masterIntake || [],
  courses: data.courses || [],
  strengthsHighlights: data.strengthsHighlights || [],
});

// ✅ Map form data to Firestore data
const mapFormToFirestore = (data: any) => ({
  universityName: data.universityName || "",
  slug: slugify(data.universityName || ""),
  intro: data.intro || "",
  keyInfo: data.keyInfo || [],
  rankings: data.rankings || [],
  campus: data.campus || [],
  country: data.country || "",
  degreeIntake: data.degreeIntake || [],
  diplomaIntake: data.diplomaIntake || [],
  foundationIntake: data.foundationIntake || [],
  masterIntake: data.masterIntake || [],
  courses: data.courses || [],
  strengthsHighlights: data.strengthsHighlights || [],
});

export default function EditUniversity() {
  const { id } = useParams();
  const [initialData, setInitialData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ✅ Fetch university data on mount
  useEffect(() => {
    const fetchUniversity = async () => {
      if (!id) return;
      try {
        const docRef = doc(db, "university-listing", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setInitialData(mapFirestoreToForm(docSnap.data()));
        }
      } catch (error) {
        console.error("Error fetching university:", error);
        showErrorToast("Failed to load university data");
      } finally {
        setLoading(false);
      }
    };

    fetchUniversity();
  }, [id]);

  // ✅ Handle form submit
  const handleSubmit = async (formData: any) => {
    if (!id) return;
    try {
      const firestoreData = mapFormToFirestore(formData);
      await updateDoc(doc(db, "university-listing", id), firestoreData);
      showSuccessToast("University updated successfully");
      navigate("/university-listing");
    } catch (error: any) {
      console.error("Error updating university:", error);
      showErrorToast(error?.message || "Failed to update university");
    }
  };

  const handleCancel = () => {
    navigate("/university-listing");
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Edit University</h2>
      <UniForm
        initialData={initialData}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  );
}
